class ConfirmLeaving {
  constructor(activate = false) {
    this.handleBeforeUnload = this.showWarning.bind(this);
    activate && this.activate();
  }

  activate(activate = true) {
    if(activate) {
      addEventListener('beforeunload', this.handleBeforeUnload);
    } else {
      removeEventListener('beforeunload', this.handleBeforeUnload);
    }
  }

  deactivate() {
    this.activate(false);
  }

  showWarning(event) {
    event.preventDefault(); // The "right" way…
    event.returnValue = ''; // …but Chrome needs this
  }
}

export { ConfirmLeaving };
export default ConfirmLeaving;
